import { agentClient, AgentDto } from 'api/planning';
import { api } from '../api';

export const agentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getActiveAgentsForCentre: builder.query<AgentDto[], void>({
      query: () => agentClient.getActiveAgentsForCentre(),
    }),
  }),
});

export const { useGetActiveAgentsForCentreQuery } = agentsApi;
